import React, { useCallback, useEffect, useMemo, useState } from "react"
import classnames from "classnames"
import "./ViewTimeTable.css"
import { Col, Row, Spinner } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import {
  getTimeTable,
} from "store/actions"

const ViewTimeTable = () => {
  const dispatch = useDispatch()

  const { Loading, timeTableDays, timeTable, HideCol } = useSelector(
    state => state.TimeTableReducer
  )
  const [selectedDay, setSelectedDay] = useState("")
  const [showDay, setShowDay] = useState("")

  const today = new Date()
  const currentDayName = moment(today).format("dddd")

  const handleGetTimeTable = useCallback(
    day => {
      dispatch(getTimeTable({ dayid: day.id }))
      setSelectedDay(day.id)
      setShowDay(day.day)
    },
    [dispatch]
  )

  const daysElements = useMemo(() => {
    if (!Array.isArray(timeTableDays)) return null

    return timeTableDays.map((data, index) => (
      <div
        key={index}
        className={classnames("days", {
          selectedDay: selectedDay === data.id,
        })}
        onClick={() => handleGetTimeTable(data)}
      >
        {data.day.slice(0, 3)}
      </div>
    ))
  }, [timeTableDays, selectedDay, handleGetTimeTable])

  const uniqueObjects = useMemo(() => {
    if (!Array.isArray(timeTable)) return []

    return [
      ...new Map(
        timeTable.map(item => [
          item.lecture_Time || item.lecturetime,
          item,
        ])
      ).values(),
    ]
  }, [timeTable])

  const timetableElements = useMemo(() => {
    if (!Array.isArray(uniqueObjects) || uniqueObjects.length === 0) {
      return <p className="text-center">No timetable available for the selected day.</p>
    }

    return uniqueObjects.map((data, index) => (
      <Row key={index}>
        <Col xs="2" className="p-0">
          <div className="leftNumberContainer">
            <span className="leftNumber">{index + 1}</span>
          </div>
        </Col>
        <Col xs="10" className="border border-bottom py-2 ps-1">
          <div className="rightContainer">
            <div className="lectureData">
              <p className="m-0 time">
                {data.teacherid ? data.subject : data.lecture_Time}
                {data.teacherid ? "" : data.period ? ` (${data.period})` : ""}
              </p>

              {HideCol?.subjecthide !== "1" && (
                <>
                  <p className="m-0 lecture">{data.value}</p>
                  <p className="m-0 time">{data.teacher}</p>
                  {data.teacherid && (
                    <p className="m-0 lecture">{data.lecturetime}</p>
                  )}
                </>
              )}

              {HideCol?.teacherhide !== "1" && (
                <p className="m-0 teacherName">
                  {data.teacherid ? data.div_name : data.teachersName}
                </p>
              )}
            </div>

            {data.meeting_ID && (
              <div className="meetingID">
                <a href={data.meeting_ID} target="_blank" rel="noreferrer">
                  <i className="fas fa-video" />
                </a>
              </div>
            )}
          </div>
        </Col>
      </Row>
    ))
  }, [uniqueObjects, HideCol])

  useEffect(() => {
    if (Array.isArray(timeTableDays) && timeTableDays.length > 0) {
      const todayObj = timeTableDays.find(day => day.day === currentDayName)
      if (todayObj) {
        handleGetTimeTable(todayObj)
      }
    }
  }, [timeTableDays, handleGetTimeTable, currentDayName])


  return (
    <div className="page-content px-0 bg-white" style={{ paddingTop: "62px" }}>
      <div className="timeTableContainer">
        <div className="dayTableContainer position-fixed w-100">
          {daysElements}
        </div>

        <div className="pt-5">
          <hr className="mt-2" />
          <p className="text-primary m-2 fs-5">{showDay}</p>
          <hr className="mt-2 mb-0" />
        </div>

        {Loading ? (
          <div
            className="w-100 d-flex flex-column align-items-center justify-content-center"
            style={{ height: "65vh" }}
          >
            <Spinner className="mt-4 text-primary" />
          </div>
        ) : (
          <div className="subContainer">{timetableElements}</div>
        )}
      </div>
    </div>
  )
}

export default ViewTimeTable
